<template>
	<div class="invoce-bg invoce-list-bg">
        <header class="lmy-header lmy-header-w">
            <i class="iconfont icon-yuyin" @click="routetokPage('/user')"></i>
            我的发票
        </header>
		<div class="lmy-invoce-menu invLlist">
			<div class="list-menu" v-for="item in dataList" :key="item.OrderOrBillNo" @click="$router.push('/invoiceDetails?orderNo='+item.OrderOrBillNo)">
				<div class="titleBox"><span class="title">{{item.OrderOrBillNo}}</span> <span class="has">{{item.InvoiceStatus}}</span></div>
                <!-- <p class="OrderOrNo">{{item.OrderOrBillNo}}</p> -->
                <p style="padding-top: 15px;">{{item.InvoiceKind}}</p>
								<p class="price">金额：<span class="price-icon">￥<span>{{item.Accounts}}</span></span></p>
                <p class="time">{{item.TaxpayerIdentifyNo}}<span class="invDetails">查看详情</span></p>
				</div>
				<!-- <div class="list-menu" @click="routetokPage('/invoiceDetails')">
                <div class="titleBox"><span class="title">CN123456789</span> <span class="has">已开票</span></div>
                <p style="padding-top: 15px;">电子发票</p>
								<p class="price">金额：<span class="price-icon">￥<span>79</span></span></p>
                <p class="time">2019-01-29<span class="invDetails">查看详情</span></p>
				</div> -->
				<div v-if="dataList.length==0" style="text-align: center;line-height: .8rem;">暂时没有发票...</div>
		</div>

	</div>

</template>
<script>
	export default{
		name:'user',
		data(){
			return{
				dataList:[]
			}
		},
		methods:{
			initData(){
				this.postRequest({
						url:this.Api.InvoiceSearch,
						params:{}
					}).then(res => {
						if (res && res.IsSuccess) {
							this.dataList = res.Result
						}else{
                    		this.error({title: '提示', content: res.Msg});

						}
						
				});	
			}
		},
		mounted(){
			this.initData()
		}
			
	}
</script>


// WEBPACK FOOTER //
// src/components/invoice/list.vue